<template>
	<div class="business-type-card" :class="{active, small}">
		<div class="img" :style="'--card-bg-image:url('+imageSrc+')'"></div>
		<div class="card-title-container">
			<h4>{{ title }}</h4>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		active: {
			type: Boolean,
			required: true
		},
		value: {
			type: String,
			required: true
		},
		imageSrc: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		small: {
			type: Boolean,
			default: false
		}
	},
	name: "AppBusinessTypeCard",
}
</script>

<style scoped lang="scss">
	.business-type-card {
		@include noSelect;
		cursor: pointer;
		background-color: var(--color-alpha-1);
		border-radius: 20px;
		padding: 10px;
		color: var(--color-primary);
		width: 150px;
		transition: background-color .3s $transition;

		.img {
			width: 140px;
			height: 140px;
			max-width: 100%;
			margin-bottom: 10px;
			border-radius: 13px;
			overflow: hidden;
			position: relative;

			&:after {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-image: var(--card-bg-image);
				background-size: cover;
				background-repeat: no-repeat;
				background-position: center;
				transition: transform .3s $transition .1s;
			}
		}

		&:hover {
			background-color: var(--color-alpha-2);
		}
		&:hover .img:after {
			transform: scale(1.1);
		}
		&.active {
			border: 1px solid var(--color-primary);
		}

		.card-title-container {
			@include centered;
			min-height: 50px;
			h4 {
				@include truncateString(3);
				text-align: center;
				padding: 0 5px;
			}
		}

		&.small {
			width: 100px;
			.img {
				width: 90px;
				height: 90px;
			}
			.card-title-container {
				h4 {
					font-size: 14px;
				}
			}
		}

	}
</style>